import { useState } from 'react'

import styles from './infographic_grid.module.sass'

import classNames from 'classnames'

import BlockWrapper from './layout/block_wrapper'
import Image from './basic/image'
import Button from './basic/button'
import ScrollAnimation from './layout/scroll_animation'


function InfographicGrid(props) {
	let fields = props.fields
	const [state, setState] = useState({
		items: fields.items.map((item, i) => {
			return {...item, original_order: i}
		})
	})

	function handleExpand(i){
		setState((prevState) => {
			const updatedItems = [...prevState.items]
			updatedItems[i] = {
			  ...updatedItems[i],
			  expanded: !updatedItems[i].expanded,
			}

			//move updatedItems[i] to first position of array
			if(updatedItems[i].expanded == true){
				//find last item in array with expanded == true and does not match i using lastIndexOf
				let lastExpanded = updatedItems.map((item, index) => index != i && item.expanded == true).lastIndexOf(true)
			
				//if found, move to next position after lastExpanded
				if(lastExpanded != -1){
					updatedItems.splice(lastExpanded + 1, 0, updatedItems.splice(i, 1)[0])
				} else {
					//if not found, move to first position
					updatedItems.splice(0, 0, updatedItems.splice(i, 1)[0])
				}

			} else {
				//move item to next position after all expanded == true items
				let lastExpanded = updatedItems.map((item, index) => index != i && item.expanded == true).lastIndexOf(true)

				if(lastExpanded != -1){
					updatedItems.splice(lastExpanded + 1 + updatedItems[i].original_order, 0, updatedItems.splice(i, 1)[0])
				} else {
					//move to original position based on index
					updatedItems.splice(updatedItems[i].original_order, 0, updatedItems.splice(0, 1)[0])
				}
			}

			return { items: updatedItems }
		})
	}

	return <BlockWrapper {...props} className={classNames(styles.infographic_grid)}>
		<ScrollAnimation styles={styles}>
			<div className={classNames(styles.infographic_grid_wrapper)}>
			{state.items && state.items.map((item, i) => {
				return <div key={i} className={classNames(styles.item_wrapper, item.expanded == true ? styles.expanded : '')} style={{order: item.expanded ? i : i}}>
				<div className={styles.infographic_wrapper}>
					{item.infographic && <Image {...item.infographic} className={styles.infographic} />}
					<span className={styles.expander} 
						onClick={() => handleExpand(i)}
					/>
				</div>
				<div className={styles.content_wrapper}>
					{item.title &&
						<h3 className={styles.title} dangerouslySetInnerHTML={{__html: item.title}}></h3>
					}
					{item.content &&
						<div className={styles.content} dangerouslySetInnerHTML={{__html: item.content}} />
					}
					{item.button && 
						<Button fields={{button: item.button, button_style: item.button_style}}>{item.button.title}</Button>
					}
				</div>
			</div>
			})}
			</div>
		</ScrollAnimation>
	</BlockWrapper>
}

export default InfographicGrid